import React, { useState, useEffect } from "react";

const PermissionTable = ({ permissionOptions, onPermissionChange, parentPermissions }) => {

  const handlePermissionChange = (event) => {
    const value = parseInt(event.target.value);
    const isChecked = event.target.checked;

    if (isChecked) {
      onPermissionChange([...parentPermissions, value]);
    } else {
      const filteredList = parentPermissions.filter((item) => item !== value);
      onPermissionChange(filteredList);
    }
  };
  
  return (
    <div>
      <table className="table table-sm">
        <thead>
          <tr>
            <th className="text-left">ID</th>
            <th className="text-left">Name</th>
            <th className="text-left">Model</th>
            <th className="text-center">Permission</th>
          </tr>
        </thead>
        <tbody>
          {permissionOptions.map((i) => (
            <tr key={i.id}>
              <td className="text-left">{i.id}</td>  
              <td className="text-left">{i.name}</td>  
              <td className="text-left">{i.codename}</td>
              <td className="text-center">
                <label>
                  Value {i.id}
                  <input
                    type="checkbox"
                    onChange={handlePermissionChange}
                    value={i.id}
                    checked={parentPermissions.includes(i.id) }
                    name="perm"
                  />
                </label>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};


export default PermissionTable;
